// extracted by mini-css-extract-plugin
export default {"headerWrapper":"GameDetailsHeader_headerWrapper__fEg4W"};